// "Free delivery unlocked" pop-up. Shows once when the cart total crosses €50 (dmhShip.goal).
(function () {
  if (window.__dmhShipInit) return;
  window.__dmhShipInit = true;
  var KEY = 'dmhShipPrevTotal';
  var cfg = window.dmhShip || { total: 0, goal: 5000 };

  function read() { try { var v = sessionStorage.getItem(KEY); return v === null ? null : Number(v); } catch (e) { return null; } }
  function write(v) { try { sessionStorage.setItem(KEY, String(v)); } catch (e) {} }

  function show() {
    if (document.querySelector('.dmh-ship-pop')) return;
    var el = document.createElement('div');
    el.className = 'dmh-ship-pop';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="dmh-ship-pop__card">' +
      '<span class="dmh-ship-pop__tick" aria-hidden="true"></span>' +
      '<p class="dmh-ship-pop__title">Congratulations!</p>' +
      '<p class="dmh-ship-pop__text">You’ve unlocked <strong>free delivery</strong> on your order.</p>' +
      '<button type="button" class="dmh-ship-pop__btn">Continue</button>' +
      '</div>';
    function close() { el.classList.remove('is-open'); setTimeout(function () { el.remove(); }, 250); }
    el.addEventListener('click', function (e) { if (e.target === el || e.target.closest('.dmh-ship-pop__btn')) close(); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    setTimeout(close, 6000);
  }

  function check(total) {
    var prev = read();
    if (prev !== null && prev < cfg.goal && total >= cfg.goal) show();
    write(total);
  }

  function fromBar() {
    var bar = document.querySelector('.dmh-ship[data-total]');
    return bar ? Number(bar.dataset.total) : null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var t = fromBar();
    check(t === null ? cfg.total : t);
    // Cart page and drawer re-render the bar after quantity changes.
    new MutationObserver(function () {
      var t2 = fromBar();
      if (t2 !== null && t2 !== read()) check(t2);
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
